import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class ThisOrThatProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public introduction?: Types["MarkdownText"];
  @Inlet(Accepts.ThisOrThatPairList)
  public options?: Types["ThisOrThatPairList"];
}

export const ThisOrThatDefinition = defineElement(
  "this-or-that",
  ThisOrThatProps,
  {
    versionRequired: "0.80.0",
  }
);

export const THIS_OR_THAT_ACTIONS = {
  onAllAnswered: "on-all-answered",
};

export interface ThisOrThatState {
  currentPair: number;
  done: boolean;
  selectedId?: string | null;
}
